<div [ngClass]="classes" [class.placeholder]="isPlaceholder">
  <div
    class="checkbox-image"
    [class.folder]="isFolder"
    [class.draggable-mirror-content-hidden]="!small && !isFolder"
  >
    @if (!small && !storageUtilsService.fileIsTrash(file.item)) {
      <div class="select-checkbox" [class.selected]="file.selected">
        <mat-checkbox
          #selectCheckbox="matCheckbox"
          (click)="$event.stopPropagation()"
          (change)="fileSelect.emit(file)"
          [checked]="file.selected"
          matTooltip="Bulk select"
          matTooltipShowDelay="500"
          matTooltipClass="menu-tooltip"
          matTooltipPosition="above"
          [attr.aria-labelledby]="'file-label-' + index"
          class="draggable-mirror-content-hidden"
        />
      </div>
    }
    <div
      class="image-container"
      [class.tw-d-none]="file.selected && isFolder"
      [class.tw-bg-gray-50]="isPlaceholder"
      [class.draggable-mirror-content-hidden]="!small && !isFolder"
    >
      @if (isVideo) {
        <video preload="metadata">
          <source [src]="imgSrc" type="video/mp4" />
        </video>
      } @else if (isFolder && !storageUtilsService.fileIsTrash(file.item)) {
        <mat-icon svgIcon="folder"></mat-icon>
      } @else if (isFolder && storageUtilsService.fileIsTrash(file.item)) {
        <mat-icon svgIcon="trash"></mat-icon>
      } @else {
        <img loading="lazy" alt="Image thumbnail" [src]="imgSrc" />
      }
    </div>
  </div>
  @if (!small) {
    <div
      class="list-item-label tw-flex tw-flex-col"
      [class.tw-justify-center]="isFolder"
    >
      <span
        id="file-label-{{ index }}"
        class="tw-font-medium tw-overflow-hidden tw-text-ellipsis"
      >
        {{ file.item.name | storageFileName: folderPath }}
      </span>
      @if (!isFolder) {
        <span
          class="tw-text-xl tw-text-gray-600 draggable-mirror-content-hidden"
        >
          {{ getFileTimeCreated() | date: 'dd-MMM-yyyy' }} -
          {{ getFileSize() | storageFileSize }}
        </span>
      }
    </div>
  }
</div>
